/**
 * Constants for all product types
 * @module services/content/product-types
 */
export const PRODUCT_TYPE_EPISODE = 'episode'
export const PRODUCT_TYPE_SEGMENT = 'segment'
export const PRODUCT_TYPE_SINGLE = 'single'

export const PRODUCT_TYPE_EPISODIC = 'episodic'
export const PRODUCT_TYPE_SEGMENTED = 'segmented'
